import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[appCollapseContent]',
  exportAs: 'appCollapseContent',
  standalone: false
})
export class CollapseContentDirective {

  @HostBinding('class.show')
  showing = false;
}
